import { useState } from 'react';
import { AuroraTab } from '../aurora/components/AuroraTab';

interface TabSwitcherProps {
  verixa: React.ReactNode;
}

export function TabSwitcher({ verixa }: TabSwitcherProps) {
  const [activeTab, setActiveTab] = useState<'verixa' | 'aurora'>('verixa');

  return (
    <div className="w-full">
      {/* Tab Bar */}
      <div className="sticky top-0 z-50 backdrop-blur-md bg-[#050505]/80 border-b border-[#1a1a1e]">
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex gap-1">
          <button
            onClick={() => setActiveTab('verixa')}
            className={`px-6 py-3 font-semibold transition border-b-2 ${
              activeTab === 'verixa'
                ? 'border-[#7a00ff] text-[#7a00ff] glow-purple'
                : 'border-transparent text-text-muted hover:text-white'
            }`}
          >
            Vérixa
          </button>
          <button
            onClick={() => setActiveTab('aurora')}
            className={`px-6 py-3 font-semibold transition border-b-2 ${
              activeTab === 'aurora'
                ? 'border-[#6a3dd8] text-[#6a3dd8] glow-cyan'
                : 'border-transparent text-text-muted hover:text-white'
            }`}
          >
            Aurora
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'verixa' && <div>{verixa}</div>}
        {activeTab === 'aurora' && <AuroraTab />}
      </div>
    </div>
  );
}
